// MARK://dhk8/pos/lib/queries/floor
// Queries tipadas de plano/sesiones — F4.1 / ADR-0009. El POS lee el floor por el
// grafo (pos-floor), tenant del JWT. Escrituras (mover/crear mesa, sesiones) siguen REST.
import { graphql } from '../../gql/index.js'

export const PosFloorMapsQuery = graphql(`
  query PosFloorMaps($branchId: String) {
    floorMaps(branchId: $branchId) {
      id
      tenantId
      branchId
      name
      widthPx
      heightPx
      isDefault
      active
      createdAt
      updatedAt
      sections { id mapId name color sortOrder }
      tables { id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status }
    }
  }
`)

export const PosFloorSessionsQuery = graphql(`
  query PosFloorSessions($branchId: String) {
    floorSessions(branchId: $branchId) {
      id
      tableId
      tenantId
      branchId
      orderId
      covers
      serverId
      openedAt
      closedAt
      turnMinutes
      joinCode
    }
  }
`)

export const PosReservationsQuery = graphql(`
  query PosReservations($branchId: String, $date: String, $from: String, $to: String, $status: String) {
    reservations(branchId: $branchId, date: $date, from: $from, to: $to, status: $status) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`);

export const PosWaitlistQuery = graphql(`
  query PosWaitlist($branchId: String, $status: String, $includeHistory: Boolean) {
    waitlist(branchId: $branchId, status: $status, includeHistory: $includeHistory) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

// ── F8.1 / ADR-0009: escrituras de reservas por el grafo (tenant del JWT) ──────
export const PosCreateReservationMutation = graphql(`
  mutation PosCreateReservation($input: PosCreateReservationInput!) {
    createReservation(input: $input) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`);

export const PosUpdateReservationMutation = graphql(`
  mutation PosUpdateReservation($id: ID!, $input: PosUpdateReservationInput!) {
    updateReservation(id: $id, input: $input) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`);

export const PosCancelReservationMutation = graphql(`
  mutation PosCancelReservation($id: ID!) {
    cancelReservation(id: $id) {
      id tenantId branchId tableId name phone email partySize reservedAt durationMin status
      notes allergies highChair wheelchair occasion source confirmedAt cancelledAt seatedSessionId
      reservationCode reservationDay createdAt
    }
  }
`);

// ── F9.8 / ADR-0008: escrituras de la cola (waitlist) por el grafo (tenant del JWT) ──
export const PosAddWaitlistMutation = graphql(`
  mutation PosAddWaitlist($input: PosCreateWaitlistInput!) {
    addWaitlistEntry(input: $input) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

export const PosNotifyWaitlistMutation = graphql(`
  mutation PosNotifyWaitlist($id: ID!) {
    notifyWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

export const PosSeatWaitlistMutation = graphql(`
  mutation PosSeatWaitlist($id: ID!, $input: PosSeatWaitlistInput!) {
    seatWaitlistEntry(id: $id, input: $input) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

export const PosLeaveWaitlistMutation = graphql(`
  mutation PosLeaveWaitlist($id: ID!) {
    leaveWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

export const PosMoveWaitlistMutation = graphql(`
  mutation PosMoveWaitlist($id: ID!, $direction: String!) {
    moveWaitlistEntry(id: $id, direction: $direction) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

export const PosNoShowAttemptWaitlistMutation = graphql(`
  mutation PosNoShowAttemptWaitlist($id: ID!) {
    noShowAttemptWaitlistEntry(id: $id) {
      id tenantId branchId name phone partySize status notes estimatedWaitMin position
      noShowAttempts addedAt notifiedAt seatedAt seatedSessionId queueCode queueDay
    }
  }
`);

// ── F9.8 / ADR-0008: escrituras de MESAS por el grafo (IDOR-guard map del JWT) ──
export const PosCreateFloorTableMutation = graphql(`
  mutation PosCreateFloorTable($mapId: ID!, $input: PosCreateFloorTableInput!) {
    createFloorTable(mapId: $mapId, input: $input) {
      id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status
    }
  }
`);

export const PosUpdateFloorTableMutation = graphql(`
  mutation PosUpdateFloorTable($mapId: ID!, $tableId: ID!, $input: PosUpdateFloorTableInput!) {
    updateFloorTable(mapId: $mapId, tableId: $tableId, input: $input) {
      id mapId sectionId code capacity shape posX posY widthPx heightPx rotation status
    }
  }
`);

export const PosDeleteFloorTableMutation = graphql(`
  mutation PosDeleteFloorTable($mapId: ID!, $tableId: ID!) {
    deleteFloorTable(mapId: $mapId, tableId: $tableId)
  }
`);

// ── F9.8 / ADR-0008: escrituras de SECCIONES por el grafo (IDOR-guard map del JWT) ──
export const PosCreateFloorSectionMutation = graphql(`
  mutation PosCreateFloorSection($mapId: ID!, $input: PosCreateFloorSectionInput!) {
    createFloorSection(mapId: $mapId, input: $input) {
      id mapId name color sortOrder
    }
  }
`);

export const PosDeleteFloorSectionMutation = graphql(`
  mutation PosDeleteFloorSection($mapId: ID!, $sectionId: ID!) {
    deleteFloorSection(mapId: $mapId, sectionId: $sectionId)
  }
`);

// ── F9.8 / ADR-0008: escrituras de SESIONES de mesa por el grafo (tenant del JWT) ──
export const PosOpenTableSessionMutation = graphql(`
  mutation PosOpenTableSession($tableId: ID!, $input: PosOpenTableSessionInput!) {
    openTableSession(tableId: $tableId, input: $input) {
      id tableId tenantId branchId orderId covers serverId openedAt closedAt turnMinutes joinCode
    }
  }
`);

export const PosCloseTableSessionMutation = graphql(`
  mutation PosCloseTableSession($sessionId: ID!, $input: PosCloseTableSessionInput) {
    closeTableSession(sessionId: $sessionId, input: $input) {
      id tableId tenantId branchId orderId covers serverId openedAt closedAt turnMinutes joinCode
    }
  }
`);
